import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { doInitializeRequest } from 'ducks/ai/operations'
import { CONVERSATION_TYPE, CREATE_REPLY_ACTION } from 'ducks/ai/types'

import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import Reply from '@groovehq/internal-design-system/lib/assets/icons/Reply'

import ActionIcon from '../ActionIcon'
import { styles } from '../styles'

export default function ReplyDraft() {
  const dispatch = useDispatch()

  const onClick = useCallback(
    () => {
      dispatch(doInitializeRequest(CONVERSATION_TYPE, CREATE_REPLY_ACTION))
    },
    [dispatch]
  )

  return (
    <div className="grui flex items-center">
      <ActionIcon>
        <Reply />
      </ActionIcon>

      <span css={styles.actionTitle}>Draft reply</span>

      <Button
        className="grui ml-auto px-6"
        type="tertiary"
        size="small"
        onClick={onClick}
        css={styles.actionButton}
      >
        Generate
      </Button>
    </div>
  )
}
